<!-- <template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template> -->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    // 注册一个方法
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  mounted () {
    localStorage.removeItem('vuex')
    // 此方法刷新页面时也会执行
    // window.addEventListener("beforeunload", e => {
    //   if (sessionStorage.getItem("tokenStr")) {
    //   } else {
    //     // localStorage.removeItem("tokenStr");
    //   }
    // });
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
</style>
